export default __webpack_public_path__ + "static/media/personaluser.a0400b1e.svg";